import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00080-card-altimeo-controle',
  templateUrl: './p00080-card-altimeo-controle.component.html',
  styleUrls: ['./p00080-card-altimeo-controle.component.scss'],
  imports: [TranslatePipe, LargedTuileComponent],
})
export class P00080CardAltimeoControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: any[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00080.card.state.off',
        statusTitle: 'P00080.card.state.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00080.card.state.regul',
        statusTitle: 'P00080.card.state.on',
        icon: 'fa-kit fa-picto-programme',
        color: 'color-green',
        status: 'active',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.INJECTION_CLPH,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.clph'),
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
